import { render, staticRenderFns } from "./mensageria-data-list.vue?vue&type=template&id=71d5f747"
import script from "./mensageria-data-list.vue?vue&type=script&lang=js"
export * from "./mensageria-data-list.vue?vue&type=script&lang=js"
import style0 from "./mensageria-data-list.vue?vue&type=style&index=0&id=71d5f747&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports